var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      attrs: {
        title: _vm.formData.id ? "修改球队" : "添加球队",
        visible: _vm.dialogFormVisible,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.rewriteClearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: {
            rules: _vm.rules,
            model: _vm.formData,
            "label-width": "100px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              staticStyle: { width: "100%" },
              attrs: { prop: "height", label: "能力标签" }
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    placeholder: "请选择",
                    disabled: _vm.allCapacityList.length === 0
                  },
                  model: {
                    value: _vm.selectedCapacityId,
                    callback: function($$v) {
                      _vm.selectedCapacityId = $$v
                    },
                    expression: "selectedCapacityId"
                  }
                },
                _vm._l(_vm.allCapacityList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id }
                  })
                }),
                1
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "20px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.addContent }
                },
                [_vm._v("添加")]
              )
            ],
            1
          ),
          _vm._l(_vm.formData.score, function(domain, index) {
            return _c(
              "div",
              { key: index + "k", staticClass: "param_keysClass" },
              [
                _c(
                  "div",
                  { staticClass: "lodingItem-operationFrame flex" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "score." + index + ".value",
                          rules: _vm.rules.value,
                          "label-width": "60px",
                          label: domain.name
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "operationFrame-entity",
                          attrs: {
                            type: "Number",
                            clearable: "",
                            placeholder: "请输入"
                          },
                          model: {
                            value: domain.value,
                            callback: function($$v) {
                              _vm.$set(domain, "value", $$v)
                            },
                            expression: "domain.value"
                          }
                        })
                      ],
                      1
                    ),
                    _c("el-button", {
                      staticStyle: { margin: "0 10px 24px 10px" },
                      attrs: {
                        size: "mini",
                        type: "danger",
                        circle: "",
                        icon: "el-icon-delete"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.removeContent(domain)
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            )
          })
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "200px" },
              attrs: { round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.reqLoading, round: "" },
              on: {
                click: function($event) {
                  return _vm.dataFormSubmit()
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }